export default __webpack_public_path__ + "static/media/wi_02n_few_clouds.efb11345.svg";